// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".from-price{font-size:13px;margin-top:3px}.neu-grid-card{border:1px solid #eaeaea;border-radius:10px;margin-top:70px;padding:20px 10px;transition:.3s}.neu-grid-card:hover{border:1px solid #06a5d0;box-shadow:none!important;transition:.3s}@media only screen and (max-width:540px){.col-lg-2-half{flex:0 0 50%;max-width:50%}}@media only screen and (min-width:450px) and (max-width:768px){.col-lg-2-half{flex:0 0 33.33%;max-width:33.33%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
